import { ViewDefinitionTransformer } from 'components/molecules/views';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { defaultGroupedFilter } from 'components/organisms/tasks/utils';
import {
  from_grouped_filter,
  to_grouped_filter,
} from 'components/pages/api-grouped-filter-transformer';
import { GroupFieldsMeta } from 'components/pages/filter-transformer';
import { FilterGroupType } from 'components/pages/types';
import { ViewPresetId } from '../scheduler-config/view-presets/constants';
import {
  ApiResourceManagementViewDefinition,
  ApiZoomLevel,
  ResourceManagementViewDefinition,
  ResourceManagmentViewType,
} from './types';

export const ViewPresetParser = {
  toUiFormat: (level: ApiZoomLevel): ViewPresetId => {
    switch (level) {
      case ApiZoomLevel.Day:
        return ViewPresetId.Day;
      case ApiZoomLevel.Month:
        return ViewPresetId.Month;
      case ApiZoomLevel.Week:
      default:
        return ViewPresetId.Week;
    }
  },
  toApiFormat: (viewId: ViewPresetId): ApiZoomLevel => {
    switch (viewId) {
      case ViewPresetId.Month:
      case ViewPresetId.MonthZoomed:
        return ApiZoomLevel.Month;
      case ViewPresetId.Day:
      case ViewPresetId.DayZoomed:
        return ApiZoomLevel.Day;
      case ViewPresetId.Week:
      case ViewPresetId.WeekZoomed:
      default:
        return ApiZoomLevel.Week;
    }
  },
};

export const getViewDefinitionTransformer = (
  lookup: GroupFieldsMeta,
  defaultGroup: FilterGroupType,
  view: ResourceManagmentViewType,
): ViewDefinitionTransformer<
  ApiResourceManagementViewDefinition,
  ResourceManagementViewDefinition
> => ({
  from: ({
    filter: viewDefinitionFilter,
  }: ApiResourceManagementViewDefinition): ResourceManagementViewDefinition => ({
    filter: viewDefinitionFilter
      ? from_grouped_filter(lookup, defaultGroup)(viewDefinitionFilter)
      : defaultGroupedFilter(defaultGroup),
  }),
  to: ({
    filter: viewDefinitionFilter,
  }: ResourceManagementViewDefinition): ApiResourceManagementViewDefinition => {
    const isFilterValid =
      viewDefinitionFilter.groupCriteria.filter((x) =>
        FieldFilter.isValid(x.criteria),
      ).length > 0;

    return {
      filter: isFilterValid
        ? to_grouped_filter(viewDefinitionFilter)
        : undefined,
      allocations: {
        view,
      },
    };
  },
});
